import SiteDrawerData from 'Data/SiteDrawerData';
import AccountDetails from 'Pages/Accounts/ChargeAccounts/AccountDetails';
import PropTypes from 'prop-types';

import styles from './SiteDrawerContainer.module.css';

const AccountDrawerButton = ({ accountId, label, drawerTitle, ...props }) => {
  let drawerContent = accountId != null && (
    <AccountDetails {...props} accountId={accountId} />
  );

  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: drawerTitle,
    });
  };

  return (
    label && (
      <span className={styles.drawer_button_text} onClick={onClick}>
        {label}
      </span>
    )
  );
};

AccountDrawerButton.propTypes = {
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  drawerTitle: PropTypes.string,
};

export default AccountDrawerButton;
